export enum DriverStatus {
  DELEGATION = 'delegation',
  FREE = 'free',
  UNAVAILABLE = 'unavailable',
  ARCHIVED = 'archived',
  UNASSIGNED = 'unassigned',
}
